(() => {
  const options = new Map([
    ['manual', 'Recommended'],
    ['created-descending', 'New'],
    ['price-descending', 'Price (High to Low)'],
    ['price-ascending', 'Price (Low to High)']
  ]);

  const updateSortMenus = () => {
    document.querySelectorAll('#SortBydesktop, #SortBymobile').forEach((select) => {
      Array.from(select.options).forEach((option) => {
        if (!options.has(option.value)) {
          option.remove();
          return;
        }

        const label = options.get(option.value);
        if (option.textContent !== label) option.textContent = label;
      });

      if (!options.has(select.value)) select.value = 'manual';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSortMenus, { once: true });
  } else {
    updateSortMenus();
  }

  document.addEventListener('paginate', updateSortMenus);
})();